import AuditsCard from "@components/AuditsCard";
import usePageData from "@hooks/usePageData";

const TOKEN = process.env.NEXT_PUBLIC_TOKEN;
const Audits = () => {
  const auditsData =
    usePageData(
      "$.page.data.right_sections.data[?(@.attributes.key=='audits')]"
    )[0]?.attributes || {};

  const audits = usePageData("$.page.data.audits")[0];

  return (
    <AuditsCard
      title={auditsData?.title}
      subTitle={
        TOKEN === "ETH"
          ? "Undergoing smart contract audits by top security firms"
          : auditsData?.sub_title
      }
      auditsData={audits?.audits_data || []}
    />
  );
};

export default Audits;
